module.exports = __webpack_public_path__ + "img/3w.35084ad2.svg";